import React from "react";
import ReactDOM, { Container } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import smoothscroll from 'smoothscroll-polyfill'
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./styles.css";

smoothscroll.polyfill()
const root = ReactDOM.createRoot(document.getElementById("root") as Container);

root.render(
    <React.StrictMode>
      <ToastContainer />
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
